<div class="wrapper">
  <div class="left">
    <div class="logo">
      <img src="./assets/images/logo.svg" alt="logo" />
    </div>
  </div>
  <div class="right">
    <div class="center">
      @if (identityProviderResponse !== null) {
        @if (identityProviderResponse.providers.length === 1 && identityProviderResponse.providers[0] === 'PASSWORD') {
          <form class="password-container" (ngSubmit)="signInWithPassword()">
            <label translate="COMMON.PASSWORD"></label>
            <input required type="password" name="password" [(ngModel)]="password" />

            @if (isPasswordValid()) {
              <div class="button-container">
                <button type="submit" mat-button>
                  {{ 'COMMON.LOG_IN' | translate }}
                  <mat-icon iconPositionEnd>arrow_forward</mat-icon>
                </button>
              </div>
            }
          </form>
          <div class="register-container">
            <span translate="LOGIN.FORGOT_PASSWORD"></span>&nbsp;<a href="mailto:info@wiseworks.ai" translate="LOGIN.FORGOT_PASSWORD_REQUEST"></a>
          </div>
        } @else {
          <div class="identity-provider-options-container">
            @for (identityProviderOption of identityProviderResponse.providers; track identityProviderOption) {
              <a
                [href]="
                  '/api/oauth-login-public/redirect-oauth?provider=' +
                  identityProviderOption +
                  '&type=AUTH&redirect_url=' +
                  redirectUrl +
                  (identityProviderResponse.organizationId !== null ? '&organization_id=' + identityProviderResponse.organizationId : '')
                "
              >
                <div class="identity-provider-option">
                  <img [src]="'./assets/images/login/' + (identityProviderOption | lowercase) + '.png'" />
                  <div class="title" [translate]="'LOGIN.CONTINUE_WITH_' + identityProviderOption"></div>
                </div>
              </a>
            }
          </div>
          <div class="register-container">
            <span translate="LOGIN.NO_ACCOUNT"></span>&nbsp;<a href="https://brief-ai.com/schedule" translate="LOGIN.GET_IN_TOUCH"></a>
          </div>
        }
      } @else {
        <form class="email-container" (ngSubmit)="submitEmail()">
          <input required type="email" name="email" [(ngModel)]="email" placeholder="yourname@company.com" />

          @if (isValidEmail) {
            <div class="button-container">
              <button type="submit" mat-button>
                {{ 'COMMON.LOG_IN' | translate }}&nbsp;
                <mat-icon iconPositionEnd>arrow_forward</mat-icon>
              </button>
            </div>
          }
        </form>
        @if (showUnknownEmailWarning) {
          <div class="banner-container">
            <mat-icon class="icon-warning">warning</mat-icon>
            <div class="warning-text">{{ 'LOGIN.EMAIL_NOT_REGISTERED' | translate }}</div>
          </div>
        }
        @if (showUserDeactivatedWarning) {
          <div class="banner-container">
            <mat-icon class="icon-warning">warning</mat-icon>
            <div class="warning-text">{{ 'LOGIN.USER_DEACTIVATED' | translate }}</div>
          </div>
        }
      }
    </div>
    <div class="footer-text">© 2024 Brief AI. All rights reserved. | <a href="/privacy">Privacy Policy</a></div>
  </div>
</div>
